import React from 'react';
import styles from './ProblemSection.module.css';
// Import the new icons we'll use
import { FaBullhorn, FaRegClock, FaPhoneSlash } from 'react-icons/fa';

const ProblemSection = () => {
  return (
    <section className={styles.problemSectionWrapper}>
      <div className={styles.problemSection}>
        {/* Updated Main Headlines */}
        <h2 className={styles.mainHeadline}>You're a master of your instrument.</h2>
        <h3 className={styles.subHeadline}>You shouldn't have to master web design and scheduling chaos, too.</h3>
        <p className={styles.introText}>Does this sound like your studio?</p>
        
        <div className={styles.columns}>
          {/* Column 1: Website Issues */}
          <div className={styles.column}>
            <FaBullhorn size={50} color="#22E4AC" />
            <h3>No Professional Website?</h3>
            <p>
              Your current website looks outdated or you don't have one at all, making it hard to attract serious students.
            </p>
          </div>
          
          {/* Column 2: Scheduling Issues */}
          <div className={styles.column}>
            <FaRegClock size={50} color="#22E4AC" />
            <h3>Scheduling Nightmare?</h3>
            <p>
              Endless back-and-forth emails, double bookings, and missed appointments are draining your time and energy.
            </p>
          </div>
          
          {/* Column 3: Missing Students */}
          <div className={styles.column}>
            <FaPhoneSlash size={50} color="#22E4AC" />
            <h3>Students Can't Find You?</h3>
            <p>
              Without a professional online presence and easy booking system, potential students choose competitors instead.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;